import { defaults, getAPIMethod } from 'typed/api';
import { ExtractAction, entityActionSet, networkAction } from './utils';

export const
    analysisCategories = entityActionSet(defaults.AnalysisCategory, {
        loadAll: networkAction('LOAD_ALL_ANALYSIS_CATEGORIES', getAPIMethod('AnalysisCategory', 'loadAll')),
        add: networkAction('ADD_ANALYSIS_CATEGORY', getAPIMethod('AnalysisCategory', 'add')),
        edit: networkAction('EDIT_ANALYSIS_CATEGORY', getAPIMethod('AnalysisCategory', 'edit')),
        delete: networkAction('DELETE_ANALYSIS_CATEGORY', getAPIMethod('AnalysisCategory', 'delete'))
    });

export type AnalysisAction = ExtractAction<
| typeof analysisCategories
>;
